import { useQuery } from "react-query";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const useProjectMembers = (projectId) => {
  const fetchContext = useContext(FetchContext);
  return useQuery(["project", projectId.toString(), "members"], async () => {
    const { data } = await fetchContext.authAxios.get(
      `/projects/${projectId}/members`
    );
    return data;
  });
};
